import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
// import Logo from '../Header/synergytop-logo.webp';
import MachadaloLogo from '../Header/machadalo-logo.png';
import TestLogo from '../Header/synergytop-logo.webp';

const Logo = process.env.REACT_APP_SUBDOMAIN_POSTFIX === '.synergytop.com' ? TestLogo : MachadaloLogo;
const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Adaptable performance',
    description:
      'Our product effortlessly adjusts to your needs, boosting efficiency and simplifying your tasks.',
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Built to last',
    description:
      'Experience unmatched durability that goes above and beyond with lasting investment.',
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Great user experience',
    description:
      'Integrate our product into your routine with an intuitive and easy-to-use interface.',
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Innovative functionality',
    description:
      'Stay ahead with features that set new standards, addressing your evolving needs better than the rest.',
  },
];

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 2, maxWidth: 450 }}
    >
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        <img
          src={Logo}
          alt="Synergytop Logo"
          style={{ maxWidth: 100 }}
        />
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium',fontSize:{xs:'16px',sm:'16px'}}}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary',fontSize:{xs:'14px',sm:'14px'}}}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}


// import * as React from 'react';
// import Box from '@mui/material/Box';
// import Stack from '@mui/material/Stack';
// import Typography from '@mui/material/Typography';
// import PsychologyIcon from '@mui/icons-material/Psychology';
// import SchoolIcon from '@mui/icons-material/School';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
// import MachadaloLogo from '../Header/machadalo-logo.png';
// import TestLogo from '../Header/synergytop-logo.webp';

// const Logo = process.env.REACT_APP_SUBDOMAIN_POSTFIX === '.synergytop.com' ? TestLogo : MachadaloLogo;

// const items = [
//   {
//     icon: <PsychologyIcon sx={{ color: 'primary.main', fontSize: 40 }} />,
//     title: 'Deep AI Technology',
//     description:
//       'Powered by epistemic AI that understands not just "what" but "why" - building true comprehension.',
//   },
//   {
//     icon: <EmojiObjectsIcon sx={{ color: 'warning.main', fontSize: 40 }} />,
//     title: 'Curiosity-Driven Learning',
//     description:
//       'Transform wonder into knowledge with our adaptive learning framework that nurtures natural curiosity.',
//   },
//   {
//     icon: <SchoolIcon sx={{ color: 'success.main', fontSize: 40 }} />,
//     title: 'Zero Compartmentalization',
//     description:
//       'Complete K-12 NCERT knowledge mapping ensures foundational understanding across all levels.',
//   },
//   {
//     icon: <TrendingUpIcon sx={{ color: 'info.main', fontSize: 40 }} />,
//     title: 'Performance Analytics',
//     description:
//       'Dynamic testing and passion mapping to track progress and identify areas for growth.',
//   },
// ];

// export default function Content() {
//   return (
//     <Stack
//       sx={{ 
//         flexDirection: 'column', 
//         alignSelf: 'center', 
//         gap: { xs: 2, md: 3 }, 
//         maxWidth: 450,
//         px: { xs: 2, sm: 0 }
//       }}
//     >
//       <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' }, mb: { xs: 2, md: 0 } }}>
//         <img
//           src={Logo}
//           alt="Logo"
//           style={{ maxWidth: 120, height: 'auto' }}
//         />
//       </Box>
      
//       <Typography 
//         variant="h5" 
//         sx={{ 
//           fontWeight: 'bold', 
//           mb: 1,
//           display: { xs: 'block', md: 'none' },
//           textAlign: 'center',
//           color: 'primary.main'
//         }}
//       >
//         Welcome to DeTAiL
//       </Typography>

//       {items.map((item, index) => (
//         <Stack 
//           key={index} 
//           direction="row" 
//           sx={{ 
//             gap: 2,
//             p: { xs: 2, sm: 1.5 },
//             borderRadius: 2,
//             transition: 'all 0.3s ease',
//             '&:hover': {
//               backgroundColor: 'action.hover',
//               transform: 'translateX(8px)',
//             }
//           }}
//         >
//           <Box sx={{ 
//             display: 'flex', 
//             alignItems: 'center',
//             minWidth: { xs: 48, sm: 40 }
//           }}>
//             {item.icon}
//           </Box>
//           <Box sx={{ flex: 1 }}>
//             <Typography 
//               gutterBottom 
//               sx={{ 
//                 fontWeight: 600,
//                 fontSize: { xs: '16px', sm: '16px' },
//                 lineHeight: 1.4,
//                 mb: 0.5
//               }}
//             >
//               {item.title}
//             </Typography>
//             <Typography 
//               variant="body2" 
//               sx={{ 
//                 color: 'text.secondary',
//                 fontSize: { xs: '14px', sm: '14px' },
//                 lineHeight: 1.5
//               }}
//             >
//               {item.description}
//             </Typography>
//           </Box>
//         </Stack>
//       ))}

//       <Box 
//         sx={{ 
//           mt: 2,
//           p: 2,
//           backgroundColor: 'primary.light',
//           borderRadius: 2,
//           textAlign: 'center',
//           display: { xs: 'block', md: 'none' }
//         }}
//       >
//         <Typography 
//           variant="caption" 
//           sx={{ 
//             color: 'primary.dark',
//             fontWeight: 500,
//             fontSize: '13px'
//           }}
//         >
//           Deep Technology using AI in Learning
//         </Typography>
//       </Box>
//     </Stack>
//   );
// }